/**
 * Servicio de locales — Portal Cliente Menuee
 *
 * Responsabilidad: resolver el tenant público por slug (sin SELECT en locales).
 * Consume rpc_resolver_local_por_slug (SECURITY DEFINER, columnas mínimas).
 */

import { supabase } from "../supabaseClient";
import { normalizarSlug } from "../utils/slugUrl";

/**
 * @typedef {Object} LocalPortal
 * @property {string} id
 * @property {string} slug
 * @property {string} nombre
 * @property {boolean} activo
 */

/**
 * @param {string} slug
 * @returns {Promise<LocalPortal|null>}
 */
export async function resolverLocalPorSlug(slug) {
  const normalizado = normalizarSlug(slug);
  if (!normalizado) {
    return null;
  }

  const { data, error } = await supabase.rpc("rpc_resolver_local_por_slug", {
    p_slug: normalizado,
  });

  if (error) {
    throw error;
  }

  const row = Array.isArray(data) ? data[0] : data;
  if (!row || !row.id) {
    return null;
  }

  return {
    id: String(row.id),
    slug: String(row.slug || normalizado),
    nombre: String(row.nombre || "").trim(),
    activo: row.activo !== false,
  };
}
